import { gql } from 'urql';

export const incentiveStatusFields = gql`
  fragment incentiveStatusFields on IncentiveStatus {
    id
    status
    optedInAt
    measurementStart
    measurementEnd
    awards {
      id
      amount {
        amount
        currency
      }
      drawingId
      drawingAwardId
      determinedAt
      fulfillmentStatus
      fulfilledAt
    }
  }
`;
